import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AuthLayout from 'src/layout/AuthLayout';
import AppLayout from 'src/layout/AppLayout';
import AppLoader from 'src/layout/AppLoader';
import AppRouter from './router';
import 'src/assets/css/fonts.css';
import 'src/assets/css/app.css';
import { AppearanceProvider } from 'src/context/AppearanceContext';
import { authPages } from 'src/config';
import { restoreSession } from 'src/modules/auth/store/authActions';
import { useLocation } from 'react-router-dom';
import Toast from './components/shared/Toast';

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  const loading = useSelector((state) => state.app?.appLoading);

  if (loading) return <AppLoader />;

  return (
    <AppearanceProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Toast>
          {authPages.includes(location.pathname) ? (
            <AuthLayout>
              <AppRouter />
            </AuthLayout>
          ) : (
            <AppLayout>
              <AppRouter />
            </AppLayout>
          )}
        </Toast>
      </LocalizationProvider>
    </AppearanceProvider>
  );
}

export default App;